import { apiRequest } from './apiClient';

const buildQueryString = (params) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') {
      return;
    }
    query.set(key, String(value));
  });
  return query.toString();
};

export const fetchProjectDocuments = async (projectId, options = {}) => {
  const query = buildQueryString({
    page: Number.isInteger(options.page) ? options.page : 1,
    itemsPerPage: Number.isInteger(options.itemsPerPage) ? options.itemsPerPage : 15,
    sortBy: options.sortBy || 'name',
    search: options.search || '',
  });

  return apiRequest(`/api/v1/projects/${encodeURIComponent(projectId)}/documents${query ? `?${query}` : ''}`);
};

export const fetchProjectChartData = async (projectId, options = {}) => {
  const query = buildQueryString({
    variable: options.variable || '',
    aggregation: options.aggregation || 'day',
    timeRange: options.timeRange || '24month',
    showEmptyDates: options.showEmptyDates ? 'true' : 'false',
  });

  return apiRequest(`/api/v1/projects/${encodeURIComponent(projectId)}/chart-data${query ? `?${query}` : ''}`);
};

export const fetchProjectTimelineTrendData = async (projectId, options = {}) => {
  const query = buildQueryString({
    aggregation: options.aggregation || 'month',
    timeRange: options.timeRange || '6month',
    showEmptyDates: options.showEmptyDates ? 'true' : 'false',
    filter: options.filter || '',
    showHidden: options.showHidden ? 'true' : 'false',
  });

  return apiRequest(`/api/v1/projects/${encodeURIComponent(projectId)}/timeline-trend${query ? `?${query}` : ''}`);
};

export const fetchProjectSummary = async (projectId, options = {}) => {
  const query = buildQueryString({
    forceRefresh: options.forceRefresh ? 'true' : '',
  });

  return apiRequest(`/api/v1/projects/${encodeURIComponent(projectId)}/summary${query ? `?${query}` : ''}`);
};

export const fetchProject = async (projectId) => {
  return apiRequest(`/api/v1/projects/${encodeURIComponent(projectId)}`);
};

export const updateProject = async (projectId, payload = {}) => {
  const response = await apiRequest(
    `/api/v1/projects/${encodeURIComponent(projectId)}`,
    {
      method: 'PATCH',
      body: JSON.stringify(payload),
    }
  );
  return response.data ?? response;
};

export const updateProjectCoordinateSecondPass = async (projectId, enabled) => {
  return updateProject(projectId, {
    ingestionCoordinateSecondPassEnabled: Boolean(enabled),
  });
};

export const fetchProjectVisionPageCrops = async (projectId) => {
  const response = await apiRequest(
    `/api/v1/projects/${encodeURIComponent(projectId)}/preferences/vision-page-crops`
  );
  return response.data ?? response;
};

export const updateProjectVisionPageCrops = async (projectId, enabled) => {
  const response = await apiRequest(
    `/api/v1/projects/${encodeURIComponent(projectId)}/preferences/vision-page-crops`,
    {
      method: 'POST',
      body: JSON.stringify({
        vision_page_crops: Boolean(enabled),
      }),
    }
  );
  return response.data ?? response;
};

export const fetchProjectPdfVisionPageCrops = fetchProjectVisionPageCrops;
export const updateProjectPdfVisionPageCrops = updateProjectVisionPageCrops;

export const fetchProjectFilePasswords = async (projectId) => {
  const response = await apiRequest(
    `/api/v1/projects/${encodeURIComponent(projectId)}/file-passwords`
  );
  return response.data ?? response;
};

export const updateProjectFilePasswords = async (projectId, filePasswords = []) => {
  const response = await apiRequest(
    `/api/v1/projects/${encodeURIComponent(projectId)}/file-passwords`,
    {
      method: 'POST',
      body: JSON.stringify({
        file_passwords: Array.isArray(filePasswords) ? filePasswords : [],
      }),
    }
  );
  return response.data ?? response;
};
